<div class="warning" *ngIf="shown">

  <app-message-toggle
      type="warning"
      toggleStyle="flat"
      icon="info-circle"
      [dismiss]="true"
      (handleDismiss)="handleDismiss()">

      <div>
        This model appears to be performing slowly on your device. For an optimal experience, please switch to a different device or try another model.
      </div>

  </app-message-toggle>

</div>
